export interface ISolucionConfiguracion {
  maxNumberOfSolicitudesPerUser?: number | null;
  anioSolucion?: number;
}

export class SolucionConfiguracion implements ISolucionConfiguracion {
  constructor(public maxNumberOfSolicitudesPerUser?: number | null, public anioSolucion?: number) {}
}
